// @flow

import React from 'react';
import { AsYouType } from 'libphonenumber-js';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import CheckboxInput from './CheckboxInput';
import RadioInput from './RadioInput';
import BooleanInput from './BooleanInput';

type PhoneFieldProps = {
  placeholder: string,
  onChange: (number: string) => void,
  value: string
}

export const PhoneNumberField = (props: PhoneFieldProps) => (
  <div className='react-phone-number-input'>
    <label className='react-phone-number-input__row control' htmlFor='phone_field'>
      <input
        name='phone_field'
        className='input text-input react-phone-number-input__phone'
        placeholder={props.placeholder}
        value={props.value ? new AsYouType('US').input(props.value) : ''}
        onChange={props.onChange}
        type='phone'
      />
    </label>
  </div>
);

type FieldProps = {
  ref: string,
  name: string,
  label: string,
  onChange: (SyntheticInputEvent, string) => void,
  value?: string,
  error?: string,
  type?: string,
  groupClassName?: string,
  inputClassName?: string,
  labelClassName?: string,
  placeholder: string,
  required: boolean,
  inputRef: string
}

export const Field = ({
  inputRef,
  name,
  label,
  value,
  onChange,
  error,
  type,
  groupClassName,
  inputClassName,
  labelClassName,
  placeholder,
  required
} : FieldProps) => (
  <div className={groupClassName}>
    <input
      ref={inputRef}
      type={type}
      name={name}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      className={inputClassName}
      required={required}
    />
    <label
      htmlFor={name}
      className={labelClassName}
    >{label}
    </label>
    <p className='dark-red'>{error}</p>
  </div>
);

Field.defaultProps = {
  error: '',
  type: 'text',
  className: '',
  groupClassName: '',
  inputClassName: '',
  labelClassName: '',
  value: ''
};

type DateFieldProps = {
  name: string,
  value: string,
  label: string,
  onChange: (any) => void,
  error?: string,
  className?: string,
  format?: string,
  placeholder: string,
  groupClassName: string,
  inputClassName: string
}

export const DateField = ({
  groupClassName,
  inputClassName,
  value,
  onChange,
  error,
  format,
  placeholder
} : DateFieldProps) => {
  const date = (value && moment(value, format).isValid()) ?
    moment(value, format) :
    null;

  return (
    <div className={groupClassName}>
      <DatePicker
        selected={date}
        onChange={onChange}
        showMonthDropdown
        showYearDropdown
        dropdownMode='select'
        dateFormat={format}
        placeholderText={placeholder}
        className={inputClassName}
        required
      />
      <p className='dark-red'>{error}</p>
    </div>
  );
};

DateField.defaultProps = {
  error: '',
  type: 'text',
  className: '',
  format: 'YYYY/MM/DD',
  groupClassName: '',
  inputClassName: '',
  labelClassName: ''
};

type MultipleChoiceProps = {
  question: {
    name: string,
    text: string,
    answers: {
      id: number,
      text: string
    },
    multiple_choice: boolean
  },
  currentAnswers: [],
  groupClassName?: string,
  onAnswerChange: (any, any) => void,
  onChange: (Event) => void,
  isRequired: boolean,
  answers: any[],
  label: string
}

export class MultipleChoice extends React.Component {
  onChange = (e: Event) => {
    this.props.onChange(e);
  }

  props: MultipleChoiceProps

  render() {
    const { question, onChange, answers } = this.props;
    if (question.multiple_choice) {
      return (
        <CheckboxInput
          options={question.answers}
          selectedOptions={answers}
          setAnswers={this.onChange}
        />
      );
    }
    if (question.answers.length === 2) {
      return (
        <BooleanInput
          options={question.answers}
          selectedOption={answers[0]}
          setAnswer={onChange}
        />
      );
    }
    return (
      <RadioInput
        options={question.answers}
        selectedOption={answers[0]}
        setAnswer={onChange}
      />
    );
  }
}

MultipleChoice.defaultProps = {
  type: 'text',
  className: '',
  groupClassName: '',
  inputClassName: '',
  labelClassName: ''
};



// WEBPACK FOOTER //
// ./src/components/shared/FormFields.js